module.exports = __webpack_public_path__ + "static/aws_solutions_architect-b0af12a08b2e8a5c62c35ceacb808bef.png";